import { request } from '../utils/httpClient';

export const getConversations = (data) => {
  let url = `/messages/conversations`;
  console.log('Fetching conversations from:', url);
  return request({
    url: url,
    method: 'GET',
  });
};

export const getConversationMessages = (data) => {
  let url = `/messages/conversations/${data.id}/messages`;
  console.log('Fetching messages for conversation:', url);
  return request({
    url: url,
    method: 'GET',
  });
};

export const createMessage = (data) => {
  let url = `/messages/conversations/${data.conversationId}/messages`;
  console.log('Creating message in conversation:', url);
  return request({
    url: url,
    method: 'POST',
    data: {
      message: data.message,
    },
  });
};

export const getUnreadCount = () => {
  return request({
    url: `/messages/conversations/unread`,
    method: 'GET',
  });
};
